import { SQUARES } from "chess.js";

export const turnColor = (chess) => {
    return chess.turn() === "w" ? "white" : "black";
};

export const calcMovable = (chess) => {
    const dests = new Map();
    SQUARES.forEach((s) => {
        const ms = chess.moves({ square: s, verbose: true });
        if (ms.length)
            dests.set(
                s,
                ms.map((m) => m.to),
            );
    });

    return {
        free: false,
        dests,
        color: turnColor(chess),
    };
};

export const checkIfDots = (str) => {
    if (!str) return false;
    const pattern = /(\.+)/g;
    return pattern.test(str);
};

export const checkIfOpponentFirst = (solution) => {
    if (!solution) {
        return false;
    }

    if (checkIfDots(solution[0][0]) && solution.flat().length % 2 === 1) {
        return true;
    }

    if (!checkIfDots(solution[0][0]) && solution.flat().length % 2 === 0) {
        return true;
    }

    return false;
};

export const parseSolution = (s) => {
    if (s === null || s === "" || typeof s === "undefined") {
        return null;
    }

    const commentsPattern = / +{([^}]+)}/g;
    const dollarPattern = / +\$\d+?/g;

    const pattern = /(\d+\.)/; // finds [number followed by a dot ];
    const solution = s
        .split(pattern)
        .map((item) => {
            const filtered = item
                .replace(commentsPattern, "")
                .replace(dollarPattern, "")
                .trim();
            if (!pattern.test(filtered) && filtered !== "")
                return filtered
                    .trim()
                    .split(" ")
                    .filter(function (element) {
                        return element !== "";
                    });
        })
        .filter(function (element) {
            return element !== undefined;
        });
    return solution;
};

export const sleepTimeout = (interval) => {
    return new Promise((resolve) => {
        setTimeout(resolve, interval);
    });
};

export const getCheckColor = (chess) => {
    return chess.inCheck() ? turnColor(chess) : null;
};

export function getFirstTurnColor(parsedSolution) {
    if (!parsedSolution) {
        return "white";
    }

    if (checkIfDots(parsedSolution)) {
        return "black";
    }
    return "white";
}
